import React from 'react'
import createFilterOptions from 'react-select-fast-filter-options'
import VirtualizedSelect from 'react-virtualized-select'
import Client from '../../client'

// @TODO(jackson) make this run on click, loading states, error states
export default class CategoryPicker extends React.Component {
  state = { loading: false, categories: [] }

  componentDidMount() {
    this.fetchData()
  }

  shouldComponentUpdate(nextProps, nextState) {
    return (
      nextProps.value !== this.props.value ||
      nextState.loading !== this.state.loading ||
      nextState.categories !== this.state.categories
    )
  }

  fetchData = async () => {
    this.setState({ loading: true })
    const res = await Client.categoryIndex()

    const categories = res.data.categories.map(c => ({ value: c.id, label: c.pathCache }))

    this.setState({
      categories,
      loading: false
    })
  }

  render() {
    const { categories } = this.state
    return (
      <div style={{ maxWidth: this.props.width || '720px', flex: 1, width: this.props.width || '720px' }}>
        <VirtualizedSelect
          autoFocus={this.props.autoFocus}
          className="long-select"
          onChange={this.props.onChange}
          value={this.props.value}
          optionHeight={20}
          isLoading={this.state.loading}
          labelKey="label"
          valueKey="value"
          placeholder={this.props.placeholder}
          simpleValue={this.props.simpleValue === undefined ? true : this.props.simpleValue}
          clearable={false}
          filterOptions={createFilterOptions({ options: categories })}
          options={categories}
        />
      </div>
    )
  }
}
